import { useRefreshFile } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateIdFileIdDelete } from "#candidate/services/api"
import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { Typography } from "@mui/material"
import { useCallback, useState } from "react"

export default function CandidateFileButtonsDialogDelete({ open, setOpen, data }) {
	const { candidateId } = useCandidateRedux()
	const { refresh } = useRefreshFile()
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		refresh()
	}

	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(candidateIdFileIdDelete, { success, end })

	const handleSubmit = useCallback(() => {
		setDisabled(true)
		fetch(candidateId, data.id)
	}, [fetch, candidateId, data.id])

	const handleClose = useCallback(() => {
		setOpen(false)
	}, [setOpen])

	return (
		<DialogMaster
			{...{
				title: `eliminar ${data?.name}`,
				setOpen,
				open,
				handleSubmit,
				disabled,
				onClose: handleClose,
			}}
		>
			<Typography variant="body1" textAlign={"center"}>
				¿Estás seguro de que deseas realizar esta acción? <br />
			</Typography>
			<Typography variant="body2" textAlign={"center"}>
				Esta acción es permanente y no se puede deshacer.
			</Typography>
		</DialogMaster>
	)
}
